import { PartCreateButton } from "./part.create.button";
import { PartCreateForm } from "./part.create.form";

export const PartCreate = {
    Button: PartCreateButton,
    Component: PartCreateForm,
}
